export default "__VITE_ASSET__Dm6ZG15q__"